import React, { Component } from 'react';
import $ from 'jquery';
import { Alert, Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import '../statics/css/input-hour.css'

class InputHour extends Component {

  constructor(props) {
    super(props);

    this.state = {

      //stepHour: this.props.stepHour,
      stepMinutes: undefined,
    };

  }

  componentWillMount() {

    if (this.props.stepMinutes) {

      let value = this.getValueFractionHour(this.props.stepMinutes);
      let beginHour = this.props.paramBeginHour.toString().substring(0, 2);
      let beginMin = this.props.paramBeginHour.toString().substring(3, 5);

      let endHour = this.props.paramEndHour.toString().substring(0, 2);
      let endMin = this.props.paramEndHour.toString().substring(3, 5);

      // console.log(this.props.paramBeginHour)
      // console.log(this.props.paramEndHour)

      this.setState({
        stepMinutes: value,
        param_BeginHour: beginHour,
        param_BeginMin: beginMin,
        param_EndHour: endHour,
        param_EndMin: endMin,
      }, () => {

        //console.log("SETANDO HOUR INTERVAL: " + this.state.param_BeginHour);

        console.log("REVERSE: " + this.props.reverse);

        // this.props.onChangeHour('hour_interval', {
        //   target: {
        //     value: this.state.param_BeginHour,
        //   }
        // })

        console.log(this.state.param_BeginHour)
        console.log(this.state.param_BeginMin)
        console.log(this.state.param_EndHour)
        console.log(this.state.param_EndMin)
      })
    }


  }

  renderOptionHours() {

    let optionsHours = [];

    //Caso seja o reverse acrescentamos 1 no end
    let end = 0;

    if (this.props.reverse) {
      end = parseInt(this.state.param_EndHour) + 1;
    } else {
      end = parseInt(this.state.param_EndHour);
    }

    //workaround para renderizar novamente após selecionar o primeiro horário
    if (this.props.rerender) {

      for (let i = parseInt(this.state.param_BeginHour); i < end; i++) {

        //console.log("HOUR: " + i);
        //Adicionando horas
        //caso seja 0 adiciona-se outro 0 para combinar com o formato da hora
        if (i == parseInt(this.state.param_EndHour) && this.props.reverse) {
          optionsHours.push(
            <option selected value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' h' : i + ' h'}</option>
          )
        } else {
          optionsHours.push(
            <option value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' h' : i + ' h'}</option>
          )
        }


      }
    } else {
      for (let i = parseInt(this.state.param_BeginHour); i < end; i++) {

        //console.log("HOUR: " + i);
        //Adicionando horas
        //caso seja 0 adiciona-se outro 0 para combinar com o formato da hora
        if (i == parseInt(this.state.param_EndHour) && this.props.reverse) {
          optionsHours.push(
            <option selected value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' h' : i + ' h'}</option>
          )
        } else {
          optionsHours.push(
            <option value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' h' : i + ' h'}</option>
          )
        }


      }
    }



    return optionsHours;
  }



  renderOptionsMinutes() {
    let optionsMinutes = [];

    // console.log("MINUTES INCIIAL: " + parseInt(this.state.param_BeginMin));
    // console.log("MINUTES FINAL: " + parseInt(this.state.param_EndMin));
    // console.log("COMPARANDO: " + parseInt(this.props.hour) + " com " + parseInt(this.state.param_BeginHour) + " = " + (parseInt(this.props.hour) == parseInt(this.state.param_BeginHour)))

    if (parseInt(this.props.hour) == parseInt(this.state.param_BeginHour)) {

      for (let i = parseInt(this.state.param_BeginMin); i < 60; i += this.state.stepMinutes) {

        optionsMinutes.push(
          <option value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' min' : i + ' min'}</option>
        )

      }
    } else {

      for (let i = 0; i < 60; i += this.state.stepMinutes) {

        optionsMinutes.push(
          <option value={i.toString().length == 1 ? '0' + i : i}>{i.toString().length == 1 ? '0' + i + ' min' : i + ' min'}</option>
        )

      }
    }



    return optionsMinutes;
  }

  getValueFractionHour(v) {

    let value = 0;

    switch (v) {
      case 1:
        value = 10;
        break;
      case 2:
        value = 15;
        break;
      case 3:
        value = 30;
        break;
      case 4:
        value = 60;
        break;
    }

    return value;
  }

  render() {
    return (
      <div className="row-input-hour">
        <FormGroup controlId="formControlsSelectHour" className={`${this.props.noMarginBottom ? 'no-m-bottom' : ''}`}>
          <FormControl componentClass="select" placeholder="select"
            onChange={(e) => { this.props.onChangeHour('hour_interval', e) }}>
            {this.renderOptionHours()}
          </FormControl>
        </FormGroup>

        <p className={`${this.props.noMarginBottom ? 'no-m-bottom' : ''}`}> : </p>

        <FormGroup controlId="formControlsSelectMinute" className={`${this.props.noMarginBottom ? 'no-m-bottom' : ''}`}>
          <FormControl componentClass="select" placeholder="select"
            onChange={(e) => { this.props.onChangeHour('minutes_interval', e) }}>>
            {this.renderOptionsMinutes()}
          </FormControl>
        </FormGroup>
      </div>
    );
  }
}

export default InputHour


// WEBPACK FOOTER //
// src/utils/input-hour.js